import React, { useState } from 'react';
import { AppBar, Button, Tab, Tabs, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import Auth from '../../util/Auth';
import PERMISSIONS_LIST from '../../util/RolesEnum';

import EditUnit from './EditUnit';
import UnitChainOfTitle from './UnitChainOfTitle';
import UnitPlat from "./UnitPlat";
import Toolbar from '@material-ui/core/Toolbar';

const hasPermissions = Auth.hasRole(PERMISSIONS_LIST.WRITE.WRITE_UNITS);

export const FormStyles = makeStyles((theme) => ({
  root: {
    paddingBottom: 50,
  },
  TextField: {
    display: 'block',
    marginTop: 10,
    marginBottom: 10,
    paddingRight: '1em',
  },
  Switch: {
    margin: 0,
  },
  BottomBar: {
    display: hasPermissions ? 'flex' : 'none',
    justifyContent: 'space-between',
  },
  positives: {
    display: 'flex',
    flexDirection: 'row',
  },
  SubmitButton: {
    display: hasPermissions ? 'inline-block' : 'none',
    maxWidth: '200px',
    maxHeight: '50px',
    minWidth: '200px',
    float: 'left',
  },
  DeleteButton: {
    display: hasPermissions ? 'inline-block' : 'none',
    maxWidth: '200px',
    maxHeight: '50px',
    minWidth: '200px',
    float: 'right',
  },
  DIButton: {
    display: hasPermissions ? 'inline-block' : 'none',
    maxWidth: '200px',
    maxHeight: '50px',
    minWidth: '200px',
  },
  FormControlLabel: {
    paddingRight: '5em',
  },
  Select: {
    display: 'block',
  },
  FullWidthTextBox: {
    marginBottom: 20,
    marginTop: 20,
  },
  paper: {
    padding: 25,
    marginBottom: '1rem',
    marginTop: '1rem',
  },
  title: {
    color: '#1976d2',
    fontSize: '1.75rem',
    textAlign: 'left',
    textDecoration: 'underline',
  },
}));

function TabContainer(props) {
  return (
    <Typography component='div' style={{ padding: 8 * 3, display: "flex", flexDirection: "column" }}>
      {props.children}
    </Typography>
  );
}

const UnitTabs = ({ match, history }) => {
  const [value, setValue] = useState(0);
  const [modalOpen, setModalOpen] = useState(false);
  const [fileUploadOpen, setFileUploadOpen] = useState(false);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        height: '100vh',
        overflowY: 'auto',
        paddingLeft: 5
      }}
    >
      <AppBar
        position='fixed'
        style={{
          display: "flex",
          marginBottom: 5,
          paddingTop: "62px",
          height: "150px"}}
      >
        <Toolbar
          style={{
            marginTop: -10,
            paddingTop: 25,
            display: 'flex',
            width: '100%',
            justifyContent: 'space-between',
            alignSelf: 'flex-start',
            paddingLeft: 215
          }}
        >
          <Tabs
            value={value}
            onChange={(event, newValue) => {
              setValue(newValue);
            }}
          >
            <Tab label='Main' />
            <Tab label='Chain Of Title' />
            <Tab label='Plat' />
          </Tabs>
          {value === 0 && (
            <div>
              <Button
                size={'small'}
                onClick={() => {
                  setModalOpen(true);
                }}
                variant='contained' color='secondary' style={{ float: 'right' }}>
                Delete
              </Button>
              <Button form="editUnit"
                      size={'small'}
                      variant='contained' color='primary' type='submit' style={{ float: 'right', marginRight: '4px' }}>
                Update
              </Button>
            </div>
          )}
          {value === 1 && (
            <div>
              <Button
                size={'small'}
                onClick={() => {
                  const fileInput = document.getElementById('addFile');
                  if (fileInput) {
                    fileInput.click();
                  }
                }}
                variant='contained' color='primary' style={{ float: 'right' }}>
                Upload
              </Button>
            </div>
          )}
          {value === 2 && (
            <div>
              <Button form="unitPlat"
                      size={'small'}
                      variant='contained' color='primary' type='submit' style={{ float: 'right', marginRight: '4px' }}>
                Update
              </Button>
            </div>
          )}
        </Toolbar>
      </AppBar>

      <div style={{ paddingTop: '80px' }}>
      {value === 0 && (
        <TabContainer>
          <EditUnit
            modalOpen={modalOpen}
            setModalOpen={setModalOpen}
            match={match} history={history} />
        </TabContainer>
      )}
      {value === 1 && (
        <TabContainer>
          <UnitChainOfTitle
              fileUploadOpen={fileUploadOpen}
              setFileUploadOpen={setFileUploadOpen}
              match={match}
              history={history}
              setValue={setValue}
          />
        </TabContainer>
      )}
      {
        value === 2 && (
            <TabContainer>
              <UnitPlat match={match} history={history} />
            </TabContainer>
        )
      }
      </div>
    </div>
  );
};

export default UnitTabs;
